<template lang="pug">
  div
    .leaning-left(v-if="list.length > 0")
      module-title(title="舆情启示")
      .list
        .list-item(v-for="(item,index) in list" :key="i")
          .title {{item.title}}
          .p {{item.content}}
    //- .list-template(v-else)
    //-   .tag learning样例
    //-   .paragraph(style="margin-bottom:15px;")
    //-     .title 海天双标事见：伪概念营销或遭反噬。
    //-     .p 海天酱油陷入的每论恶评，部分要归咎为包括海天在内的调味品行业长期“零添加 更健康"的营销洗脑，导致消费者偏见无法纠正，形成反噬效应。
    //-   .paragraph
    //-     .title 什么是learning?
    //-     .p 危机案例库借助舆情分析团队，结合舆情传播过程中的不同声音与各种风险，专业剖析点评，大幅提升案例复盘价值。
    //-     .title 为什么这个案例没有leaming?
    //-     .p 危机案例库采用异步录入的方式，后续将会补充重点案例的learning。订阅案例，将会第一时间接受到通知提醒哦
    //- .img-box(v-else)
    //-   img(src="../assets/img/event/learning.png")
</template>

<script>
import ModuleTitle from '../EventCenter/ModuleTitle'
import client from '../server/server'
export default {
  props: {
    eventId: String
  },
  // computed: {
  //   noRole () {
  //     const roleId = this.$store.getters.roleId
  //     // 铂金1和普通用户0都无权限看leaning
  //     return roleId <= 1
  //   }
  // },
  mounted () {
    this.getList()
  },
  data () {
    return {
      list: []
    }
  },
  methods: {
    getList () {
      client.getEventLearning(this.eventId).then(res => {
        this.list = res.data
      })
    }
  },
  components: { ModuleTitle }
}
</script>

<style lang="scss" scoped>
.leaning-left {
  width: 100%;
  // height: 290px;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 14px;
  margin-top: 20px;

  .no-Role-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #666;

    .blue-btn {
      margin-top: 10px;
      width: 140px;
      height: 44px;
      line-height: 44px;
      background-color: #3989cb;
      border-radius: 22px;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
      user-select: none;
    }
  }

  .list {
    margin-top: 20px;
    // height: 240px;
    overflow-y: auto;

    .list-item {
      border-bottom: 1px solid #ccc;
      padding: 10px 0;

      .title {
        color: #333;

      }

      .p {
        padding: 6px 0;
        color: #999;
        font-size: 12px;
      }
    }
  }

  .list-template {
    height: 240px;
    overflow-y: auto;

    .tag {
      margin: 20px 0;
      display: inline-block;
      font-size: 12px;
      padding: 6px 15px;
      color: #E99378;
      border: 1px solid #E99378;
      border-radius: 10px;
      border-bottom-right-radius: 0;
    }

    .paragraph {
      padding: 10px;
      background-color: #FAFAFA;
      border-radius: 5px;

      .title {
        color: #333;
      }

      .p {
        padding: 6px 0;
        color: #999;
        font-size: 12px;
      }
    }
  }

  .img-box {
    width: 100%;
    height: 220px;
    overflow-y: auto;
    margin-top: 20px;
    padding-left: 14px;
    padding-right: 20px;

    &>img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventGeneral/EventLearning.vue